import { useEffect, useState } from "react";

const useLoadingMessage = (message?: string[], delay?: number) => {
  // in case that there is message and no timeout, show message immediately
  const [showMessage, setShowMessage] = useState<boolean>(
    Boolean(message) && !delay
  );

  useEffect(() => {
    if (!delay) return undefined;
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, delay * 1000);
    return () => clearTimeout(timer);
  }, [delay]);

  return [showMessage];
};

export default useLoadingMessage;
